import { createAndMergeSliceReducer } from '../../utils/redux/create-and-merge-slice-reducer';

const sliceName = 'userSlice';

export interface UserSliceType {
  isLoading: boolean;
  error?: string;
  signupSuccess: boolean;
  inviteSuccess: boolean | null;
  inviteCodeInvalid: boolean;
  signupUsername: string | null;
  verifyPhone: boolean | null;
  shareable_url: string | null;
  is_verified: boolean;
  is_credit: boolean;
  token: string | null;
  request_default_invite_code: boolean;
  cognito_identity_result: number;
  show_player_profile_settings_bonus: boolean;
}

export const initialState: UserSliceType = {
  isLoading: false,
  error: undefined,
  signupSuccess: false,
  inviteSuccess: null,
  inviteCodeInvalid: false,
  signupUsername: null,
  verifyPhone: null,
  shareable_url: null,
  token: null,
  is_verified: false,
  request_default_invite_code: false,
  cognito_identity_result: -1,
  is_credit: false,
  show_player_profile_settings_bonus: false,
};

export const userReducer = createAndMergeSliceReducer(sliceName, initialState);
